export default __webpack_public_path__ + "static/media/WETH.2cb05cd4.svg";